import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.svg`
  ${({ theme, displayState }) => css`
    cursor: pointer;
    stroke: #E3E3E3;
    width: ${displayState.size ? displayState.size : "36px"};
    height: ${displayState.size ? displayState.size : "36px"};
    fill: none;
    &:hover {
      stroke: ${theme?.colour?.secondary ?? "#04333B"};
    }
  `}
`;

export default Atom({ type: 'button', dataType: 'object', template })

// stroke: #E3E3E3;